<template>
  <Dialog
    v-model="visible"
    class="dob-under18-check-dialog"
    :title="'Missing Patient’s DOB'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <p style="margin-bottom:16px;">Is the patient a minor (age under 18) ?</p>
    <div class="dob-radio-group">
      <div class="dob-radio-item" @click="select('yes')">
        <span class="radio-circle" :class="{checked: selection==='yes'}"></span>
        <span>Yes, the patient ages under 18.</span>
      </div>
      <div class="dob-radio-item" @click="select('no')">
        <span class="radio-circle" :class="{checked: selection==='no'}"></span>
        <span>No, the patient is 18 or older.</span>
      </div>
    </div>
    <div class="dob-dashed"></div>
    <div class="dob-actions">
      <Button colorType="none-stroke" @click="onBack">Back to patient’s DOB</Button>
  <Button colorType="dark-blue" :disabled="!selection" @click="onSubmit">Submit</Button>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/NewLibrary/Dialog.vue'
import Button from '@/NewLibrary/Button.vue'

export default {
  name: 'DobUnder18CheckDialog',
  components: { Dialog, Button },
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue','submit','back','unknown-dob'],
  data() {
    return { selection: null }
  },
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    }
  },
  methods: {
    select(val) {
      if (this.selection === val) {
        this.selection = null;
      } else {
        this.selection = val;
      }
    },
    onBack() {
      this.visible = false;
      this.$emit('back');
    },
    onSubmit() {
      this.visible = false;
      this.$emit('submit', this.selection);
    }
  }
}
</script>

<style scoped>
.dob-radio-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.dob-radio-item {
  display: grid;
  grid-template-columns: 18px 1fr;
  align-items: center;
  column-gap: 12px;
  cursor: pointer;
  font-size: 15px;
  margin-left: 140px;
}
.dob-radio-item span {
  color: #333333;
}
.radio-circle {
  width: 18px;
  height: 18px;
  border: 1px solid #1E4670;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.radio-circle.checked::after {
  content: '';
  display: block;
  width: 10px;
  height: 10px;
  background: #1E4670;
  border-radius: 50%;
}
.dob-dashed {
  border-bottom: 1px dashed #C8CDD3;
  height: 0;
  margin-top: 6px;
}
.dob-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}
.back-link {
  color: #3A5BA0;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}
</style>
